(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(scope) {
    scope.querySelectorAll('[data-atelier-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const buttons = [...hero.querySelectorAll('[data-atelier-select]')];
      const scenes = [...hero.querySelectorAll('[data-atelier-scene]')];
      const choose = index => {
        buttons.forEach((button, n) => button.setAttribute('aria-pressed', String(n === index)));
        scenes.forEach((scene, n) => { scene.hidden = n !== index; });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => choose(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          choose(next);
          buttons[next].focus();
        });
      });
      hero.addEventListener('shopify:block:select', event => {
        const scene = event.target.closest('[data-atelier-scene]');
        if (scene) choose(Number(scene.dataset.atelierScene));
      });
    });
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const items = [...scope.querySelectorAll('[data-atelier-reveal]:not(.is-revealed)')];
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: .07, rootMargin: '0px 0px 35px 0px' });
      items.forEach(item => {
        if (item.getBoundingClientRect().top < window.innerHeight) item.classList.add('is-revealed');
        else observer.observe(item);
      });
      document.documentElement.classList.add('atelier-reveal-ready');
    }
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.documentElement.classList.remove('atelier-reveal-ready');
  });
})();

// The reviews app leaves some screen-reader labels in English in its Arabic widget.
(() => {
  if (!document.documentElement.lang.startsWith('ar')) return;
  const labels = new Map([
    ['Sort reviews by', 'ترتيب المراجعات حسب'],
    ['Pagination Navigation', 'صفحات المراجعات'],
    ['Go to previous page', 'الصفحة السابقة'],
    ['Go to next page', 'الصفحة التالية'],
    ['Verified checkmark', 'تم التحقق']
  ]);
  function translate(value) {
    if (labels.has(value)) return labels.get(value);
    const page = value.match(/^Go to page (\d+)$/);
    if (page) return `انتقل إلى الصفحة ${page[1]}`;
    const stars = value.match(/^(\d+(?:\.\d+)?) out of (\d+) stars$/);
    return stars ? `${stars[1]} من ${stars[2]} نجوم` : value;
  }
  function setup() {
    document.querySelectorAll('#judgeme_product_reviews').forEach(widget => {
      if (widget.dataset.almondArabicLabels) return;
      widget.dataset.almondArabicLabels = 'true';
      const update = () => {
        widget.querySelectorAll('[aria-label], [alt]').forEach(element => {
          ['aria-label', 'alt'].forEach(attribute => {
            const value = element.getAttribute(attribute);
            if (value && translate(value) !== value) element.setAttribute(attribute, translate(value));
          });
        });
        widget.querySelectorAll('label.jdgm-visually-hidden').forEach(label => {
          const value = label.textContent.trim();
          if (labels.has(value)) label.textContent = labels.get(value);
        });
      };
      update();
      const observer = new MutationObserver(update);
      observer.observe(widget, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','alt']});
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
